
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M5.993 17.931a9 9 0 1112.753-8.183M4.022 2.8l5.28 2a1.5 1.5 0 01.944 1.7l-.313 1.568a1.5 1.5 0 01-1.108 1.161l-2.079.519-1.154 2.885a2.991 2.991 0 01-1.121 1.382l-1.83 1.257"}}),_c('path',{staticClass:"a",attrs:{"d":"M15.991 3.268l-1.467 2.925a1.5 1.5 0 00-.081 1.145L15 9"}}),_c('rect',{staticClass:"a",attrs:{"x":"9.746","y":"14.998","width":"13.5","height":"8.25","rx":"1.5","ry":"1.5"}}),_c('path',{staticClass:"a",attrs:{"d":"M12.746 14.998v8.25M20.246 14.998v8.25M14.246 15v-.75a2.25 2.25 0 014.5 0V15"}})])
          )
        }
      }
    